// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";


// const root = ReactDOM.createRoot(
//   document.getElementById("root") as HTMLElement
// );
// root.render(<App />);



//////////////////////////////
import React from "react";
import { hydrateRoot, createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";

const rootElement = document.getElementById("root") as HTMLElement;

if (rootElement.hasChildNodes()) {
  // თუ გვაქვს შვილი ელემენტები, ეს ნიშნავს რომ react-snap-მა უკვე პრე-რენდერი გააკეთა
  hydrateRoot(rootElement, <App />);
} else {
  // პირველი რენდერი ბრაუზერში
  createRoot(rootElement).render(<App />);
}